import { useTags } from "@/hooks/useTags";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { usePreviewFilterStore } from "@/stores/previewFilterStore";
import { Tag } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface PreviewTagLegendProps {
  providerId: number;
  versionId: number;
  regionId: number;
}

export function PreviewTagLegend({ providerId, versionId, regionId }: PreviewTagLegendProps) {
  const { data: tags, isLoading } = useTags(providerId, versionId, regionId);
  const {
    showTagDescription,
    showTagChannelCount
  } = usePreviewFilterStore();

  if (isLoading || !tags || tags.length === 0) {
    return null;
  }

  return (
    <div className="mb-6 border rounded-md p-4">
      <h4 className="text-sm font-medium mb-3 flex items-center gap-2">
        <Tag className="h-4 w-4" />
        Channel Tags
      </h4>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Tag Name</TableHead>
            {showTagDescription && <TableHead>Description</TableHead>}
            {showTagChannelCount && <TableHead className="text-right">Channels</TableHead>}
          </TableRow>
        </TableHeader>
        <TableBody>
          {tags.map((tag) => (
            <TableRow key={tag.id}>
              <TableCell className="font-medium">
                <div className="flex items-center gap-2">
                  <Tag className="h-4 w-4 text-muted-foreground" />
                  {tag.name}
                </div>
              </TableCell>
              {showTagDescription && (
                <TableCell className="text-muted-foreground">
                  {tag.description || '-'}
                </TableCell>
              )}
              {showTagChannelCount && (
                <TableCell className="text-right">
                  <Badge variant="secondary">
                    {tag.channel_count || 0}
                  </Badge>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
